import { useState } from "react";

import { videosStorageRef } from "../../../init/firebase";
import { applyCreateTimestamp, applyUpdateTimestamp } from "../../../utils/timestamp";
import { CollectionReference, DocReference } from "../../../types/firebase.types";

interface IUploadProgress {
  progress: number;
  error?: string | null;
  url?: string;
}

const useFirebaseFileUploader = (
  collection: CollectionReference,
  data = {
    input: "",
    src: "",
    type: "video",
    status: "draft",
    name: "",
    inputPath: "",
    outputPath: "",
    ref: null,
  }
) => {
  const [uploadProgress, setUploadProgress] = useState<IUploadProgress>({ progress: 0 });
  const [uploading, setUploading] = useState(false);

  const handleUploadToFirestore = async (firestoreDocumentRef: DocReference) => {
    const { ref, ...dataToSend } = data;
    await firestoreDocumentRef.set(applyCreateTimestamp(dataToSend));
  };

  const handleUpload = async (files: File[]) => {
    for (const file of files) {
      setUploading(true);
      const firestoreDocumentRef = collection.doc();
      await handleUploadToFirestore(firestoreDocumentRef);

      const ref = videosStorageRef.child(`input/${new Date().getTime().toString()}${file.name}`);
      const uploadTask = ref.put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setUploadProgress({ progress: Math.floor(progress) });
        },
        (ex: any) => {
          console.log(ex.message);
          setUploading(false);
        }
      );
      const uploadedSnapshot = await uploadTask;

      await firestoreDocumentRef.update(
        applyUpdateTimestamp({
          input: await ref.getDownloadURL(),
          type: "video",
          name: uploadedSnapshot.metadata.name,
          inputPath: uploadedSnapshot.metadata.fullPath,
        })
      );
      setUploading(false);
    }
  };

  return { uploadProgress, handleUpload, uploading };
};

export default useFirebaseFileUploader;
